import {Injectable} from "@angular/core";
import {Store, StoreConfig} from "@datorama/akita";
import {Customer} from "../../data-access/api-customers/Customer";

export interface AuthState extends Customer {
  token: string;
}

export function createInitialAuthState(): AuthState {
  return {
    token: `${new Date().getTime()}`
  } as AuthState;
}

@Injectable({providedIn: 'root'})
@StoreConfig({
  name: 'auth'
})
export class AuthStore extends Store<AuthState> {
  constructor() {
    super(createInitialAuthState());
  }
}
